import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadUsersAndPersonalResourcesByUserIds } from 'store/projectUsers/thunks/loadUsersAndPersonalResourcesByUserIds';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getProjectActivityFeed } from '../services/getProjectActivityFeed.service';

/** Rows of the dashboard's feed, and of each page the dialog loads more of. */
export const PROJECT_ACTIVITY_FEED_PAGE_SIZE = 20;

/**
 * Loads a page of the project's activity feed: the newest rows, or with
 * `before` (the previous page's `nextBefore`) the next older page. Users the
 * store does not know yet are loaded alongside, for their profile pictures.
 * Resolves `{ items, nextBefore }`.
 */
export const fetchProjectActivityFeed = createAsyncThunk(
  'activityLog/fetchProjectFeed',
  async ({ projectId, before }, { dispatch, getState }) => {
    const state = getState();
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    const data = await getProjectActivityFeed({
      projectId,
      limit: PROJECT_ACTIVITY_FEED_PAGE_SIZE,
      before,
      activeEmployerInfo,
    });
    const items = data?.items || [];

    const knownUsers = state.projectUsers?.users?.entities || {};
    const missingUserIds = [
      ...new Set(items.map((item) => item.userId).filter(Boolean)),
    ].filter((userId) => !knownUsers[userId]);
    if (missingUserIds.length > 0) {
      dispatch(loadUsersAndPersonalResourcesByUserIds(missingUserIds));
    }

    return { items, nextBefore: data?.nextBefore || null };
  }
);
